import type { Currency } from '@repo/shared/types';

import { useAgreementAndApprovalsContext } from '../context/use-agreement-and-approvals-context';
import type { AdvancePaymentDetails } from '../agreement-and-approvals.schema';
import { AdvancedAmountEdit } from './advanced-amount-edit';
import { AdvancedAmountPreview } from './advanced-amount-preview';

interface AgreementAndApprovalsDetailsProps {
  advancePayment: AdvancePaymentDetails;
  currency: Currency;
  withEditMode: boolean;
}

export function AdvancedAmount({
  advancePayment,
  currency,
  withEditMode,
}: AgreementAndApprovalsDetailsProps) {
  const { isEditMode } = useAgreementAndApprovalsContext();

  return (
    <>
      {withEditMode && isEditMode ? (
        <AdvancedAmountEdit advancePayment={advancePayment} currency={currency} />
      ) : (
        <AdvancedAmountPreview withEditMode={withEditMode} currency={currency} />
      )}
    </>
  );
}
